var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.4593C12.7401 13.4593 13.34 12.8594 13.34 12.1193C13.34 11.3792 12.7401 10.7793 12 10.7793C11.26 10.7793 10.66 11.3792 10.66 12.1193C10.66 12.8594 11.26 13.4593 12 13.4593Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.43976C12.7401 8.43976 13.34 7.83983 13.34 7.09977C13.34 6.3597 12.7401 5.75977 12 5.75977C11.26 5.75977 10.66 6.3597 10.66 7.09977C10.66 7.83983 11.26 8.43976 12 8.43976Z",
    fill: "#BBBBBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.4691C12.7401 18.4691 13.34 17.8691 13.34 17.1291C13.34 16.389 12.7401 15.7891 12 15.7891C11.26 15.7891 10.66 16.389 10.66 17.1291C10.66 17.8691 11.26 18.4691 12 18.4691Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.12bcc1e6c23d38f79a7762ddd562daed.svg";
export { ForwardRef as ReactComponent };